<template>
<LoginView v-if="!loginRef" @login-success="onLoginSuccess" />
<MainView v-else />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import LoginView from "@/views/LoginView.vue";
import MainView from "@/views/MainView.vue";
import { getLocalStorage, setLocalStorage } from "@/utils/localStorage";
import rest from "@/rest";
import { ElMessage } from "element-plus";

export default defineComponent({
  components: { MainView, LoginView },
  props: {},
  emits: [],
  expose: [],
  setup (props) {
    const loginRef = ref<boolean>(false);
    const token = getLocalStorage("token");
    if (token) {
      loginRef.value = true;
    }

    const onLoginSuccess = () => {
      loginRef.value = true;
    };
    return { loginRef, onLoginSuccess };
  }
});
</script>

<style scoped></style>
